import { tokens } from 'src/design-system';

export const SEQuotePanelStyles = () => ({
  loader: {
    width: '100%',
    textAlign: 'center',
    padding: tokens.spacing.lg,
  },
  errorText: {
    color: tokens.colors.error,
    fontSize: tokens.fontSize.small,
    padding: tokens.spacing.sm,
  },
});
